import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import config from '../../config.json';

import { submitCheckout, submitCheckoutCompleted, submitCheckoutFailed } from './checkoutSlice';

export const submitCheckoutEpic = (action$) =>
	action$.pipe(
		ofType(submitCheckout),
		mergeMap(async (action) => {
			const response = await axios.post(
				`${
					config[process.env.REACT_APP_STAGE].api
				}/saveonlifestyle/paymentGateway/authOnlyTransaction`,
				action.payload
			);

			return response.data;
		}),
		switchMap((res) => [submitCheckoutCompleted(res.data)]),
		catchError((error, source) => merge(of(submitCheckoutFailed(error.message)), source))
	);

export default [submitCheckoutEpic];
